import API from '@/api/callApi.js'
import endpoints from '@/api/endpoints';

export default {
  namespaced: true,
  state: {
    list: [],
    selected: {
      code: null,
      color: null,
      label: null,
      description: null,
      id: null,
    }
  },
  mutations: {
    setSegments(state, list) {
      state.list = list;
    },
    setSelectedSegment(state, segment) {
      state.selected = segment
    },
    addSegment(state, segment) {
      state.list.push(segment)
    },
    updateSegment(state, segment) {
      const index = state.list.findIndex(row => row.id === segment.id)
      if (index > -1) {
        state.list.splice(index, 1, segment)
      }
    },
    deleteSegment(state, segment) {
      const index = state.list.findIndex(row => row.id === segment.id)
      if (index > -1) {
        state.list.splice(index, 1)
      }
    }
  },
  actions: {
    async getSegment({ state, commit }, { segment_id }) {
      let segment = state.list.find(row => row.id === segment_id)
      if (segment === undefined) {
        const url = endpoints.baseURL + API.processUrl(endpoints.endpoints.segment, { segment_id })
        const response = await API.makeGet(url, null, true)
        segment = response.data.payload
      }
      commit('setSelectedSegment', segment);
    },
    getSegments({ commit }) {
      API.makeGet(endpoints.baseURL + endpoints.endpoints.segments, null, true)
        .then(response => {
          commit('setSegments', response.data.payload);
        });
    },
    addSegment({ commit }, segment) {
      return new Promise((resolve, reject) => {
        API.makePost(endpoints.baseURL + endpoints.endpoints.addSegment, segment, true)
          .then(response => {
            commit('addSegment', response.data.payload);
            commit('ui/triggerAlert', {
              type: 'success',
              msg: 'Segment ajouté avec succès'
            }, { root: true });
            resolve()
          }).catch(error => {
            commit('ui/triggerAlert', {
              type: 'error',
              msg: 'Votre segment n\'a pas pu être ajouté'
            }, { root: true });
            reject()
          })
      })
    }, updateSegment({ commit }, segment) {
      return new Promise((resolve, reject) => {
        const url = endpoints.baseURL + API.processUrl(endpoints.endpoints.updateSegment, { segment_id: segment.id })
        API.makePut(url, segment, true)
          .then(response => {
            commit('updateSegment', response.data.payload);
            commit('ui/triggerAlert', {
              type: 'success',
              msg: 'Segment mis à jour avec succès'
            }, { root: true });
            resolve()
          }).catch(error => {
            commit('ui/triggerAlert', {
              type: 'error',
              msg: 'Votre segment n\'a pas pu être mis à jour'
            }, { root: true });
            reject()
          })
      })
    }, deleteSegment({ commit }, segment) {
      return new Promise((resolve, reject) => {
        const url = endpoints.baseURL + API.processUrl(endpoints.endpoints.deleteSegment, { segment_id: segment.id })
        API.makeDelete(url, null, true)
          .then(response => {
            commit('deleteSegment', response.data.payload);
            commit('ui/triggerAlert', {
              type: 'success',
              msg: 'Segment supprimé avec succès'
            }, { root: true });
            resolve()
          }).catch(error => {
            commit('ui/triggerAlert', {
              type: 'error',
              msg: 'Votre segment n\'a pas pu être supprimé'
            }, { root: true });
            reject()
          })
      })
    }
  }
};
